import { isAccountsDepartment } from "./orgHelpers";

export const GENERAL_ACCOUNTANT_TITLE = "محاسب عام";
export const ACCOUNTS_SECTION_HEAD_TITLE = "رئيس قسم الحسابات";
export const ACCOUNTS_DEPARTMENT_MANAGER_TITLE = "مدير إدارة الحسابات";

const ADVANCE_DISBURSEMENT_ROUTER_TITLES = new Set([
  GENERAL_ACCOUNTANT_TITLE,
  ACCOUNTS_SECTION_HEAD_TITLE,
  ACCOUNTS_DEPARTMENT_MANAGER_TITLE,
]);

function isAccountsSectionHeadUser(user) {
  const title = String(user?.jobTitle || "").trim();
  if (title === ACCOUNTS_SECTION_HEAD_TITLE) return true;
  const inAccounts =
    isAccountsDepartment(user?.departmentId) || user?.departmentCode === "ACC";
  if (!inAccounts || title.includes("مدير إدارة")) return false;
  return title.includes("رئيس قسم") || title.includes("مدير قسم");
}

export function canRouteAdvanceDisbursement(user) {
  if (!user) return false;
  if (user.role === "gm" || user.role === "admin") return true;
  if (ADVANCE_DISBURSEMENT_ROUTER_TITLES.has(user.jobTitle)) return true;
  if (isAccountsSectionHeadUser(user)) return true;
  return (
    user.role === "department-manager" &&
    (isAccountsDepartment(user.departmentId) || user.departmentCode === "ACC")
  );
}

export function isAdvanceDisbursed(row) {
  return row?.disbursementStatus === "DISBURSED";
}

/** HR may edit amount/installments only before cash is handed over. */
export function canAmendApprovedAdvance(row) {
  return (
    !isAdvanceDisbursed(row) && Number(row?.installmentsPaid ?? 0) === 0
  );
}

export function canCancelApprovedAdvance(row, user) {
  if (isAdvanceDisbursed(row) || row?.status === "CANCELLED") return false;
  return (
    user?.role === "hr" || user?.role === "gm" || user?.role === "admin"
  );
}

export function localDateKey(value = new Date()) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function dateKeyFromValue(value) {
  const raw = String(value || "").slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(raw) ? raw : "";
}

export function addDaysToDateKey(dateKey, days) {
  const key = dateKeyFromValue(dateKey) || localDateKey();
  const [year, month, day] = key.split("-").map(Number);
  return localDateKey(new Date(year, month - 1, day + Number(days || 0)));
}

export function isAdvanceDisbursementPostponed(row, todayKey = localDateKey()) {
  const until = dateKeyFromValue(row?.disbursementPostponedUntil);
  return Boolean(until && until > todayKey);
}

/** Accountant may send an unpaid advance back so HR can edit or cancel it. */
export function canReturnAdvanceToHr(row, user) {
  if (!canRouteAdvanceDisbursement(user)) return false;
  if (isAdvanceDisbursed(row) || row?.status === "CANCELLED") return false;
  return (
    row?.disbursementStatus === "PENDING_ASSIGNMENT" ||
    row?.disbursementStatus === "ASSIGNED"
  );
}

export function canPostponeAdvanceDisbursement(row, user) {
  return (
    canRouteAdvanceDisbursement(user) &&
    !isAdvanceDisbursed(row) &&
    row?.disbursementStatus !== "RETURNED_TO_HR" &&
    row?.status !== "CANCELLED"
  );
}
